import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const WidgetStyled = styled(Box)(({ theme }) => ({
  borderRadius: '4px',
  backgroundColor: theme.palette.black.black3,
  height: 'auto',
  width: 'max-content',
}))
